module.exports = __webpack_public_path__ + "static/media/Ashutosh_Hathidara_Resume_ML.bad37978.pdf";